export default __webpack_public_path__ + "static/media/wix.369e8fa7.svg";